<dialog-template
  [dialogId]="dialogId"
  header="Change Owner of &quot;{{ objectToShare?.name }}&quot;"
  (primaryBtnClicked)="changeOwner()"
>
  <ng-template #contentTemplate>
    <div class="tw-flex tw-items-center">
      <label
        for="owner"
        class="tw-font-semibold tw-mr-4"
      >
        Owner
      </label>
      <p-select
        id="owner"
        [loading]="loadingUsers"
        [loadingIcon]="' fa-solid fa-circle-notch fa-spin'"
        [options]="accountUsers"
        [(ngModel)]="currentOwner"
        optionLabel="name"
        [filter]="true"
        filterBy="name"
        class="tw-w-full"
        styleClass="tw-w-full tw-text-left"
      ></p-select>
    </div>

    <p-divider align="center">
      <span class="tw-font-semibold">OR</span>
    </p-divider>

    <div class="tw-flex tw-justify-center tw-mb-6">
      <p-button
        label="Set Me As Owner"
        (onClick)="setMeAsOwner()"
      ></p-button>
    </div>
  </ng-template>
</dialog-template>
